import { IState } from 'store';

export const getIsSendingInquirySelector = (state: IState) => state.inquiries.isSending;
